import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { ConstantsModule } from '../constants/constants.module';
import { ConnectedPage } from '../root_classes/connected-page';
import { FileUploadComponent } from './../file-upload/file-upload.component';

@Component({
	selector: 'app-folder-detail',
	templateUrl: './folder-detail.component.html',
	styleUrls: ['./folder-detail.component.scss']
})
export class FolderDetailComponent extends ConnectedPage implements OnInit {

	private _folderId: string = "";
	public folderName: string = "";
	public userRole: string = "";
	public answerChoice: any[] = [];

	// Files to download list handler .
	public columnsFilesToDownload: any[] = [];
	public datasFilesToDownload: any[] = [];
	public firstFilesToDownload: number = 0;
	public rowsFilesToDownload: number = 10;

	// Uploaded files list handler.
	public columnsUploadedFiles: any[] = [];
	public datasUploadedFiles: any[] = [];
	public firstUploadedFiles: number = 0;
	public rowsUploadedFiles: number = 10;

	// Answers stats list handler .
	public columnsStatsAnswers: any[] = [];
	public datasStatsAnswers: any[] = [];
	public firstStatsAnswers: number = 0;
	public rowsStatsAnswers: number = 10;

	// Not downloaded files stats list handler.
	public columnsStatsNotDownloadedFiles: any[] = [];
	public datasStatsNotDownloadedFiles: any[] = [];
	public firstStatsNotDownloadedFiles: number = 0;
	public rowsStatsNotDownloadedFiles: number = 10;

	constructor(private activatedRoute: ActivatedRoute, constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal) {
		super(constantsModule, cookieService, httpClient, router, modalService);

		// Creating filter list.
		this.answerChoice = [
			{label: "Suivi", value:'F'},
			{label: "Non suivi", value:'NF'},
			{label: "Pas de réponse", value:'NA'},
		];
	}

	ngOnInit(): void {
		this._folderId = this.activatedRoute.snapshot.params.id;
		this.userRole = this.cookieService.get(this.constantsModule.cookieRole);

		// Loading folder details.
		this.put("/api/folder-detail", { id: this._folderId },
			(data) => {
				// Storing folder details.
				if (data.DATA == "OK") {
					this.folderName = data.FOLDERNAME;
					this.datasFilesToDownload = data.FILESTODOWNLOAD;
					this.datasStatsAnswers = data.USERSSTATSANSWERS;
					this.datasStatsNotDownloadedFiles = data.USERSSTATSNOTDOWNLOADEDFILES;
				} else {
					this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
				}
			},
			(err) => {
				this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
			}
		);

		// Init files to download list.
		this.firstFilesToDownload = 0;
		if (this.userRole == "A") {
			this.columnsFilesToDownload = [
				{field:"name", header:"Nom", sort:"name"},
				{field:"path", header:"Chemin", sort:"path"},
				{field:"size", header:"Taille", sort:"size"},
				{field:"last_date_val", header:"Date de modification", sort:"last_date_val"},
				{field:"downloads_nb", header:"Téléchargements", sort:"downloads_nb"},
			];
		} else {
			this.columnsFilesToDownload = [
				{field:"name", header:"Nom", sort:"name"},
				{field:"size_str", header:"Taille", sort:"size"},
				{field:"last_date_val", header:"Date de modification", sort:"last_date_val"}
			];
		}

		// Init uploaded files list.
		this.firstUploadedFiles = 0;
		this.columnsUploadedFiles = [
			{field:"name", header:"Nom", sort:"name"},
			{field:"size", header:"Taille", sort:"size"},
			{field:"last_date_val", header:"Date de modification", sort:"last_date_val"},
			{field:"username", header:"Utilisateur", sort:"username"},
			{field:"user_company_name", header:"Société de l'utilisateur", sort:"user_company_name"}
		];

		// Init not downloaded files stats list.
		this.firstStatsNotDownloadedFiles = 0;
		this.columnsStatsNotDownloadedFiles = [
			{field:"username", header:"Utilisateur", sort:"username"},
			{field:"notDownloadedFile", header:"Fichier non téléchargé", sort:"notDownloadedFile"},
		];

		// Init users answers stats list.
		this.firstStatsAnswers = 0;
		this.columnsStatsAnswers = [
			{field:"username", header:"Utilisateur", sort:"username"},
			{field:"answer", header:"Réponse", sort:"answer"},
		];

		// Loading data.
		this.loadSelfFiles();
	}

	public loadSelfFiles():void {
		// Load user files (depending on who you are).
		this.put("/api/folder-detail-self", {id:this._folderId},
			(data) => {
				if (data.RES == "OK") {
					this.datasUploadedFiles = data.DATA;
				} else {
					this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
				}
			},
			(err) => {
				this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
			}
		);
	}

  // =================
	// Files to download handler.
	// =================
	public prevFileToDownload(): void {
		// Set to the previous files to download page.
		this.firstFilesToDownload = this.firstFilesToDownload - this.rowsFilesToDownload;
	}

	public resetFileToDownload(): void {
		// Clear the full files to download data.
		this.firstFilesToDownload = 0;
	}

	public nextFileToDownload(): void {
		// Set to the next files to download page.
		this.firstFilesToDownload = this.firstFilesToDownload + this.rowsFilesToDownload;
	}

	public isFirstPageFileToDownload(): boolean {
    	// Test if the displayed files to download page is the first one.
		return this.datasFilesToDownload ? this.firstFilesToDownload === 0 : true;
	}

	public isLastPageFileToDownload(): boolean {
    	// Test if the displayed files to download page is the last one.
		return this.datasFilesToDownload ? (this.datasFilesToDownload.length - this.firstFilesToDownload) < this.rowsFilesToDownload : true
	}

	public hasFileToDownload(): boolean {
		// Returns if the list of the files to download table is empty.
		return this.datasFilesToDownload.length !== 0;
	}

  // =================
	// Uploaded Files handler.
	// =================
	public prevUploadedFile(): void {
		// Set to the previous uploaded files.
		this.firstUploadedFiles = this.firstUploadedFiles - this.rowsUploadedFiles;
	}

	public resetUploadedFile(): void {
		// Clear the full uploaded files data.
		this.firstUploadedFiles = 0;
	}

	public nextUploadedFile(): void {
		// Set to the next uploaded files.
		this.firstUploadedFiles = this.firstUploadedFiles + this.rowsUploadedFiles;
	}

	public isFirstPageUploadedFile(): boolean {
    	// Test if the displayed uploaded files is the first one.
		return this.datasUploadedFiles ? this.firstUploadedFiles === 0 : true;
	}

	public isLastPageUploadedFile(): boolean {
    	// Test if the displayed uploaded files is the last one.
		return this.datasUploadedFiles ? (this.datasUploadedFiles.length - this.firstUploadedFiles) < this.rowsUploadedFiles : true
	}

	public hasUploadedFile(): boolean {
		// Returns if the list of uploaded the files table is empty.
		return this.datasUploadedFiles.length !== 0;
	}

	public downloadDownloadableFile(fileName:string): void {
		window.open(this.constantsModule.serverFullURL+"/api/file-download/"+encodeURIComponent(this._folderId)+"/"+encodeURIComponent(fileName)+"?access_token="+this.cookieService.get(this.constantsModule.cookieToken));
		
		for (var index in this.datasFilesToDownload) {
			var currFile = this.datasFilesToDownload[index];
			
			if (currFile.name == fileName) {
				currFile.downloads += 1;
				currFile.downloads_nb += 1;
			}
		}
		this.datasFilesToDownload = [...this.datasFilesToDownload];
	}

	public downloadSelfFile(fileId:string): void {
		window.open(this.constantsModule.serverFullURL+"/api/file-download-self/"+encodeURIComponent(this._folderId)+"/"+encodeURIComponent(fileId)+"?access_token="+this.cookieService.get(this.constantsModule.cookieToken));
	}

	public downloadAnwsersStats(): void {
		window.open(this.constantsModule.serverFullURL+"/api/folder-export-answer-stats/"+encodeURIComponent(this._folderId)+"?access_token="+this.cookieService.get(this.constantsModule.cookieToken));
	}

	public downloadNotDownloadedFileStats(): void {
		window.open(this.constantsModule.serverFullURL+"/api/folder-export-not-downloaded-file-stats/"+encodeURIComponent(this._folderId)+"?access_token="+this.cookieService.get(this.constantsModule.cookieToken));
	}

	public doUploadFile() {
		var params = {
			folderId: this._folderId,
			size: "xl"
		};
		this.runModalDialogWithParameters(FileUploadComponent, params,
			(result:any) => {
				// Nothing: Closing.
			},
			(reason:any) => {
				this.alertLine.alertSuccessMessage = "Fichier(s) importé(s).";

				// Loading self files.
				this.loadSelfFiles();
			}
		);
	}

	// Fonctions utilitaires.
	public filterColumns(event: Event): string {
		return (<HTMLInputElement> event.target).value;
	}

	// =================
	// Not download files stats handler.
	// =================
	public prevNotDownloadedFilesStats(): void {
		// Set to the previous not downloaded files stats page.
		this.firstStatsNotDownloadedFiles = this.firstStatsNotDownloadedFiles - this.rowsStatsNotDownloadedFiles;
	}

	public resetNotDownloadedFilesStats(): void {
		// Clear the full not downloaded files stats data.
		this.firstStatsNotDownloadedFiles = 0;
	}

	public nextNotDownloadedFilesStats(): void {
		// Set to the next not downloaded files stats page.
		this.firstStatsNotDownloadedFiles = this.firstStatsNotDownloadedFiles + this.rowsStatsNotDownloadedFiles;
	}

	public isFirstPageNotDownloadedFilesStats(): boolean {
    	// Test if the displayed not downloaded files stats page is the first one.
		return this.datasStatsNotDownloadedFiles ? this.firstStatsNotDownloadedFiles === 0 : true;
	}

	public isLastPageNotDownloadedFilesStats(): boolean {
    	// Test if the displayed not downloaded files stats page is the last one.
		return this.datasStatsNotDownloadedFiles ? (this.datasStatsNotDownloadedFiles.length - this.firstStatsNotDownloadedFiles) < this.rowsStatsNotDownloadedFiles : true
	}

	public hasNotDownloadedFilesStats(): boolean {
		// Returns if the list of the not downloaded files stats table is empty.
		return this.datasStatsNotDownloadedFiles.length !== 0;
	}

	// =================
	// Answers stats handler.
	// =================
	public prevAnswersStats(): void {
		// Set to the previous answers stats page.
		this.firstStatsAnswers = this.firstStatsAnswers - this.rowsStatsAnswers;
	}

	public resetAnswersStats(): void {
		// Clear the full answers stats data.
		this.firstStatsAnswers = 0;
	}

	public nextAnswersStats(): void {
		// Set to the next answers stats page.
		this.firstStatsAnswers = this.firstStatsAnswers + this.rowsStatsAnswers;
	}

	public isFirstPageAnswersStats(): boolean {
    	// Test if the displayed answers stats page is the first one.
		return this.datasStatsAnswers ? this.firstStatsAnswers === 0 : true;
	}

	public isLastPageAnswersStats(): boolean {
    	// Test if the displayed answers stats page is the last one.
		return this.datasStatsAnswers ? (this.datasStatsAnswers.length - this.firstStatsAnswers) < this.rowsStatsAnswers : true
	}

	public hasAnswersStats(): boolean {
		// Returns if the list of the answers stats table is empty.
		return this.datasStatsAnswers.length !== 0;
	}
}
